import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const CustomerGraph = ({ offerData, bannerData }) => {
  const data = offerData || bannerData;
  const [count, setCount] = useState([]);
  const [status, setStatus] = useState([]);

  useEffect(() => {
    if (data) {
      const dataCount = data.map((item) => item.count);
      const dataStatus = data.map((item) => item._id);
      setCount(dataCount);
      setStatus(dataStatus);
    }
  }, [data]);

 
  const combinedLabels = status.map((label, index) => `${label} - ${count[index] || 0}`);
  const colors = status.map((label) => {
    if (label === "Accept") return "#025D89";
    if (label === "Pending") return "#cccccc";  
    if (label === "Reject") return "#f5422a";  
    return "#cccccc"; 
  });
  const chartOptions = {
    series: count, 
    options: {
      chart: {
        type: "donut",
      },
      labels: combinedLabels ||["Accept", "Pending","Reject"],
      colors:colors,
      legend: {
        position: "bottom",
        horizontalAlign: "center", 
        markers: {
          width: 10,
          height: 10,
          radius: 12,
        },
        itemMargin: {
          horizontal: 10, // Add horizontal spacing between items
          vertical: 5,
        },
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}`, // Show item count in tooltip
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
              horizontalAlign: "center",
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type="donut"
          height={350}
        />
      </div>
      <div>
        {/* Optional text display */}
        {/* <p className="text-[#0B1C33] text-sm">{combinedLabels.join(", ")}</p> */}
      </div>
    </div>
  );
};

export default CustomerGraph;


